import {Button, Typography} from "@mui/material";
import {Box} from "@mui/system";
import React, {useEffect, useLayoutEffect} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import SubTitle from "../../../components/SubTitle";
import {useGetQuery} from "../../../hooks/useQueryHooks";
import * as myEvalApi from "../../../api/educationApi/myEvalApi";
import MWProgress from "../../../components/MWProgress";
import {red} from "@mui/material/colors";

const StartExam = () => {
  const {id} = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const number = location.state as number;

  const {data, isLoading, isFetching} = useGetQuery<{trialCount: number; isAuth: boolean}>({
    key: ["getTrialCount", number],
    api: () => myEvalApi.getTrialCount(number),
  });

  useLayoutEffect(() => {
    if (data && data?.isAuth === false) {
      navigate("/Home/Login");
    }
  }, [data, navigate]);

  return (
    <React.Fragment>
      <SubTitle subTitle="평가 준비" />
      {isLoading && isFetching ? (
        <MWProgress />
      ) : (
        <Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              margin: "24px",
              padding: "48px 32px",
              backgroundColor: "#fff",
              boxShadow:
                "rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem",
            }}
          >
            <Typography variant="h5" sx={{marginBottom: "16px"}}>
              현재 <span style={{fontWeight: 700, color: "#053c9b"}}> {data?.trialCount}</span>회
              응시했습니다.
            </Typography>
            <Typography sx={{marginBottom: "24px", color: red[700]}}>
              시험에 응시하기 버튼을 누르면 중간에 창을 닫아도 응시한것으로 취급됩니다
            </Typography>
            <Button
              variant="contained"
              size="large"
              onClick={() => {
                navigate(`/Education/TakeExam/${id}`);
              }}
            >
              응시하기
            </Button>
          </Box>
        </Box>
      )}
    </React.Fragment>
  );
};

export default StartExam;
